import React from 'react';

import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../shared/components/table-components';
import { LbMenu } from '../../../../../../shared/components/menu-components/LbMenu/LbMenu';
import { leaderboardStore } from '../../../../../stores/leaderboardStore';
import { MenuOptions } from '../../../../../../general-types';
import { SORT_OPTIONS_BY_SCORING_RULE } from './TitleRowMobile.settings';
import { SCORING_RULE } from '../../../../../constants/scoringRule';

const TitleRowMobile = observer(() => {
  const { challengeInfo, filterMethods } = leaderboardStore;
  const { handleSort, sortData } = filterMethods;

  const { scoringRules } = challengeInfo!;

  const sortOptions: MenuOptions[] = SORT_OPTIONS_BY_SCORING_RULE[
    scoringRules || SCORING_RULE.FAT_LOSS
  ].map((option) => ({
    id: `${option.fieldName}-${option.direction}`,
    label: option.label,
    onClick: () => handleSort(option.fieldName, option.direction),
  }));

  const selectedSortId = sortData
    ? `${sortData.fieldName}-${sortData.direction}`
    : undefined;

  return (
    <GridTableRow variant="header">
      <GridTableCell>Rank</GridTableCell>
      <GridTableCell>Customer</GridTableCell>
      <GridTableCell>
        <LbMenu
          options={sortOptions}
          selectedId={selectedSortId}
          buttonProps={{
            // necessary to change icon size to match the design for next row
            endIcon: <ArrowDropDownRoundedIcon style={{ fontSize: '20px' }} />,
            variant: 'text',
            size: 'small',
            color: 'secondary',
          }}
        >
          Sort by
        </LbMenu>
      </GridTableCell>
    </GridTableRow>
  );
});

export { TitleRowMobile };
